import { lang } from '@utils/lang'

// This is the place to provide overrides when the wiki url doesn't match
// the language code

export const wikiSubdomain = lang
